type FilterPropsRes<T extends Record<string, any>> = {
	[Key in keyof T]-?: T[Key] extends undefined ? never : T[Key];
};

export function filterProps<T extends Record<string, any>>(props: T) {
	return Object.keys(props).reduce<FilterPropsRes<T>>((acc, key: keyof T) => {
		if (props[key] !== undefined) {
			acc[key] = props[key];
		}
		return acc;
	}, {} as FilterPropsRes<T>);
}

/**
 * Hook to merge component props with defined default props
 * @param defaultProps Component default props
 * @param props Component props
 * @returns Merged props
 */
export function useComponentDefaultProps<
	T extends Record<string, any>,
	U extends Partial<T> = {}
>(
	defaultProps: U,
	props: T
): [keyof U] extends [keyof T]
	? T
	: {
			[Key in Exclude<keyof T, keyof U>]: T[Key];
	  } & {
			[Key in Extract<keyof T, keyof U>]-?: U[Key] & T[Key];
	  } {
	return { ...defaultProps, ...filterProps(props) };
}
